import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=53bb32e7&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports